var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrillSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6116 17.5848L8.10584 20.5081L9.59944 21.7887L11.8032 19.2171L14.007 21.7887L15.5006 20.5081L12.9949 17.5848C15.6801 17.032 17.7049 14.6502 17.7049 11.8041H18.6885V9.83691H4.91797V11.8041H5.90158C5.90158 14.6502 7.92633 17.032 10.6116 17.5848ZM15.7376 11.8041C15.7376 13.9735 13.9726 15.7386 11.8032 15.7386C9.63387 15.7386 7.86879 13.9735 7.86879 11.8041H15.7376Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2785 7.86941H15.2457C15.2457 6.83417 14.8661 6.26417 14.5887 5.84859C14.3713 5.52253 14.2621 5.35876 14.2621 4.91859C14.2621 4.47843 14.3713 4.31466 14.5887 3.98859C14.8661 3.57302 15.2457 3.00302 15.2457 1.96777H13.2785C13.2785 2.40794 13.1693 2.57171 12.952 2.89777C12.6746 3.31335 12.2949 3.88335 12.2949 4.91859C12.2949 5.95384 12.6746 6.52384 12.952 6.93941C13.1693 7.26548 13.2785 7.42925 13.2785 7.86941Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34396 7.86941H11.3112C11.3112 6.83417 10.9315 6.26417 10.6541 5.84859C10.4367 5.52253 10.3276 5.35876 10.3276 4.91859C10.3276 4.47843 10.4367 4.31466 10.6541 3.98859C10.9315 3.57302 11.3112 3.00302 11.3112 1.96777H9.34396C9.34396 2.40794 9.23478 2.57171 9.0174 2.89777C8.74002 3.31335 8.36035 3.88335 8.36035 4.91859C8.36035 5.95384 8.74002 6.52384 9.0174 6.93941C9.23478 7.26548 9.34396 7.42925 9.34396 7.86941Z",
    fill: "#9393B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6066,
    height: 23.6066,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrillSvgrepocom);
export default __webpack_public_path__ + "static/media/grill_svgrepo.com.0ace614e0da724cd3499546d34e2a1bb.svg";
export { ForwardRef as ReactComponent };